<div class="main-content" >
    <div class="container-fluid">
        <div class="col col-sm-12 col-md-10  m-auto">
            <div class="card ">
                <div class="card-header card-header-primary p-1">
                    <div class="row">
                        <div class="col-sm-10 col-md-10">
                            <h4 class="card-title mt-2 ml-2 font-weight-bold">Reclutamiento de perfil</h4>
                        </div>
                        <div class="col-sm-2 col-md-2">
                            <button mat-icon-button (click)="onCloseClick()" tabindex="0">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body text-default">
                    <h4> Este ticket contiene una solicitud de <span class="font-weight-bold">
                        reclutamiento de perfil </span>, favor de indicar el estatus actual:
                    </h4>
                    <div>
                         <mat-chip-listbox aria-label="Estatus de reclutamiento">
                            <mat-chip-option *ngFor="let estatus of ESTATUS_RECLUTAMIENTO">
                                {{estatus}}
                            </mat-chip-option>
                           </mat-chip-listbox>
                          <mat-form-field class="example-full-width mt-3"  appearance="outline">
                            <mat-label>Comentario:</mat-label>
                            <textarea matInput aria-label="Comentario:"></textarea>
                            <mat-icon matSuffix>message</mat-icon>
                          </mat-form-field>
                    </div>  

                    <div class="text-right">
                            <button mat-raised-button class="btn btn-primary"><i class="material-icons">clear</i>Cancelar</button>
                            <button mat-raised-button class="btn btn-warning"><i class="material-icons">save</i>Guardar</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

